export const getCapabilities = ({ url }) =>
  `${url}?service=WMS&version=1.1.0&request=GetCapabilities`;
